// extracted by mini-css-extract-plugin
export var container = "_ih-0";
export var content = "_ih-3";
export var customerTitle = "_ih-4";
export var empty = "_ih-5";
export var gray = "_ih-6";
export var header = "_ih-7";
export var info = "_ih-8";
export var loading = "_ih-2";
export var loadingCard = "_ih-9";
export var oneLine = "_ih-a";
export var personName = "_ih-e";
export var pillContainer = "_ih-b";
export var selected = "_ih-1";
export var text = "_ih-c";
export var twoLines = "_ih-d";
export var unread = "_ih-f";
export var unreadIndicator = "_ih-g";